import { RouteConfig } from 'vue-router';
import { AdminRoles } from '@/configs/role';
// import { NewsTypes } from '@/configs/news';
import { NewsTypes } from '@/configs/news';
import { ProjectTypes } from '@/configs/project';
import bannerRoutes from './banner';

const homepageRoutes: RouteConfig = {
  path: 'homepage',
  component: () => import(/* webpackChunkName: 'dashboard.homepage' */ '@/pages/homepage/Index.vue'),

  children: [
    bannerRoutes,

    {
      path: 'news',
      component: () => import(/* webpackChunkName: 'dashboard.news' */ '@/pages/news/Index.vue'),
      redirect: {
        name: 'news-spotlight',
        params: {
          newsType: NewsTypes.SPOTLIGHT,
        },
      },
      children: [
        {
          path: ':newsType/list',
          name: 'news-spotlight',
          component: () => import(/* webpackChunkName: 'dashboard.news' */ '@/pages/news/List.vue'),
          meta: {
            auth: true,
            roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
          },
          beforeEnter: (to, from, next) => {
            console.log(to.params.newsType);
            if (!to.params.newsType) {
              next({
                name: 'news-spotlight',
                params: {
                  newsType: NewsTypes.SPOTLIGHT,
                },
              });
              return;
            }

            if (to.params.newsType === NewsTypes.SPOTLIGHT) {
              next();
              return;
            }

            next({
              name: 'news-spotlight',
              params: {
                newsType: NewsTypes.SPOTLIGHT,
              },
            });
          },
        },
      ],
    },

    {
      path: 'project',
      component: () => import(/* webpackChunkName: 'dashboard.project' */ '@/pages/project/Index.vue'),
      redirect: {
        name: 'project-spotlight',
        params: {
          projectType: ProjectTypes.SPOTLIGHT,
        },
      },
      children: [
        {
          path: ':projectType/list',
          name: 'project-spotlight',
          component: () => import(/* webpackChunkName: 'dashboard.project' */ '@/pages/project/List.vue'),
          meta: {
            auth: true,
            roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
          },
          beforeEnter: (to, from, next) => {
            console.log(to.params.projectType);
            if (!to.params.projectType) {
              next({
                name: 'project-spotlight',
                params: {
                  projectType: ProjectTypes.SPOTLIGHT,
                },
              });
              return;
            }

            if (to.params.projectType === ProjectTypes.SPOTLIGHT) {
              next();
              return;
            }

            next({
              name: 'project-spotlight',
              params: {
                projectType: ProjectTypes.SPOTLIGHT,
              },
            });
          },
        },
      ],
    },
  ],
};

export default homepageRoutes;
